



















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import TeamAvatar from '@/modules/shared/components/TeamAvatar'
import { TournamentEntity } from '@/api/tournament'
import { MemberMatchHistoryTeamResultEntity } from '@/api/match'
import { dateTime } from '@/utils'

@Component({
  components: {
    TeamAvatar
  },
  filters: {
    dateTime
  }
})
export default class MatchHistoryItem extends Vue {
  @Prop({ required: true }) readonly tournament!: TournamentEntity
  @Prop({ required: true }) readonly startTime!: number
  @Prop({ type: Object, required: true })
  readonly memberTeam!: MemberMatchHistoryTeamResultEntity
  @Prop({ type: Object, required: true })
  readonly opponentTeam!: MemberMatchHistoryTeamResultEntity

  @Prop({ type: Number, default: 1 }) readonly BORounds!: number
  @Prop({ type: Number, default: 32 }) readonly roundOf!: number

  /* Methods */
  async onItemClicked() {
    if (!this.tournamentId) return

    await this.$router.push({
      name: 'TournamentDetailsOverview',
      params: {
        tournamentId: this.tournamentId
      }
    })
  }

  getMatchResult(round: number) {
    switch (round) {
      case 2:
        return this.$t('MatchHistoryItem.GrandFinal')
      case 4:
        return this.$t('MatchHistoryItem.Semifinal')
      case 8:
        return this.$t('MatchHistoryItem.Quarterfinal')
      default:
        return `RO${round}`
    }
  }

  get isResultWon() {
    return this.memberTeam.result === 'Win'
  }
  get tournamentName() {
    if (!this.tournament) return '-'

    return this.tournament.name
  }

  get tournamentId() {
    if (!this.tournament) return null

    return this.tournament.tournamentId
  }
}
